import type { Autoplay as AutoplayProps } from "@src/types";
import { Cron } from "croner";
import cronstrue from "cronstrue/i18n";
import { useEffect, useMemo, useState } from "react";
import { IconContext } from "react-icons";
import { RiRemoteControlLine } from "react-icons/ri";

import { Modal } from "@src/components/Modal";

import { capitalize } from "@src/utils/capitalize";

import "./style.less";
import type { AutoplaysProps } from "./types";

function Autoplay({ id, cron, action }: AutoplayProps) {
  useEffect(() => {
    const name = `${id}_${cron}_${action}`;
    const job = new Cron(cron, { name, protect: true }, () => {
      console.log(`Autoplay ${name} triggered.`);
      if (action === "play") {
        console.log("[Autoplay] Play");
        document.dispatchEvent(new Event("remotePlay"));
      } else if (action === "stop") {
        // deleta autoplay da query string, caso esteja presente
        // necessário para garantir que o áudio ficará pausado.
        const url = new URL(window.location.href);
        url.searchParams.delete("autoplay");
        window.history.replaceState({}, document.title, url.toString());

        console.log("[Autoplay] Stop");
        document.dispatchEvent(new Event("remoteStop"));
      }
    });

    return () => {
      job.stop();
    };
  }, [id, cron, action]);

  return <></>;
}

export function Autoplays({ radio }: AutoplaysProps) {
  const [isOpen, setIsOpen] = useState(false);
  const _autoplays = useMemo(() => radio.autoplays || [], [radio.autoplays]);

  const autoplays = useMemo(() => {
    return _autoplays.map((autoplay) => (
      <Autoplay key={autoplay.id} {...autoplay} />
    ));
  }, [_autoplays]);

  return (
    <>
      <IconContext.Provider
        value={{ color: "#ffffff", className: "icon", size: "1.5em" }}
      >
        <div
          className="Autoplays-component clickable"
          onClick={() => setIsOpen(true)}
          data-tooltip-id="footer"
          data-tooltip-content="Regras de Autoplay"
          data-tooltip-class-name="text-center"
          data-tooltip-place="top"
        >
          <RiRemoteControlLine />
        </div>
      </IconContext.Provider>
      {autoplays}
      <Modal className="Autoplays-modal" isOpen={isOpen} setIsOpen={setIsOpen}>
        <h2>Regras de Autoplay</h2>
        <hr />
        <div className="list">
          {_autoplays.length === 0 ? (
            <div className="empty">Nenhuma regra de autoplay cadastrada.</div>
          ) : (
            _autoplays.map(({ id, cron, action }) => {
              const key = `${id}_${cron}_${action}`;
              const cronString = cronstrue.toString(cron, {
                use24HourTimeFormat: true,
                locale: "pt_BR",
              });
              return (
                <div key={key} className="autoplay">
                  {capitalize(action)} {cronString}
                </div>
              );
            })
          )}
        </div>
      </Modal>
    </>
  );
}
